import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
export var LockinTncAction;
(function (LockinTncAction) {
    LockinTncAction["REQUEST"] = "LOCKIN_TNC_REQUEST";
    LockinTncAction["SUCCESS"] = "LOCKIN_TNC_SUCCESS";
    LockinTncAction["ERROR"] = "LOCKIN_TNC_ERROR";
})(LockinTncAction || (LockinTncAction = {}));
export default function fetchTnc(rewardId) {
    return (dispatch) => {
        dispatch({
            type: LockinTncAction.REQUEST
        });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            pathname: `/api/1${rewardId}`,
            action: LockinTncAction.REQUEST
        })).then(json => dispatch({
            type: LockinTncAction.SUCCESS,
            data: json.RESPONSE
        }), error => {
            dispatch({
                type: LockinTncAction.ERROR,
                error
            });
        });
    };
}
